import axios from "axios";
import React, { useContext, useState } from "react";
import BaseUrl from "../BaseUrl";
import { ToastContainer, toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import Context from "../Contex/Context";
import {useHistory} from 'react-router-dom'
const ApplyPromoCode = () => {
  const history=useHistory()
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [catchRedeemCode, setCatchRedeemCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
 
  const { setCurrentPlan } =
    useContext(Context);
  function getUserCurrentPlan() {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/user/get-user-current-plan/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setCurrentPlan(response.data);
          history.push('/Pricing')
        } else {
          setCurrentPlan([]);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  const handleApplyPromoCode = () => {
    setIsLoading(true);
    if (catchRedeemCode.length !== 0) {
      axios
        .post(
          `${BaseUrl.baseurl}/email-marketing/user/add-redeem-code-user/${
            userDetails && userDetails.details._id
          }`,
          { code: catchRedeemCode.split(",").map((code) => code.trim()) },
          {
            headers: {
              Authorization: `Bearear ${userDetails && userDetails.token}`,
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            toast.success(response.data.message);
            setCatchRedeemCode("");
            getUserCurrentPlan()
          } else {
            toast.error(response.data.message);
          }
          setIsLoading(false);
        })
        .catch((err) => console.error(err));
    } else {
      if (catchRedeemCode.length === 0) {
        toast.error("At least one coupon code is required.");
      } else {
        toast.error("Only two coupon codes are allowed at a time.");
      }
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#FAFAFA",
          margin: "10px",
          borderRadius: 6,
          padding: "12px 0px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          <svg
            height="30"
            width="30"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            stroke="#1c485f"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke="#CCCCCC"
              stroke-width="0.768"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path
                d="M7 8L3 11.6923L7 16M17 8L21 11.6923L17 16M14 4L10 20"
                stroke="#1c485f"
                stroke-width="1.8960000000000001"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>{" "}
            </g>
          </svg>
          <p
            style={{
              fontWeight: 700,
              color: "#1C485F",
              fontSize: "22px",
              letterSpacing: "0.7px",
              fontFamily: "Source Sans 3",
              fontStyle: "normal",
            }}
          >
            Apply Coldsender code
          </p>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <input
            onChange={(e) => {
              setCatchRedeemCode(e.target.value);
            }}
            value={catchRedeemCode}
            type="text"
            style={{
              outline: "none",
              padding: "8px 6px",
              border: "1px solid #DDD",
              borderRadius: 4,
              flexGrow: 1,
              margin: "12px 0px",
              color: "#1c485f",
              fontWeight: 500,
            }}
            placeholder="Enter your redemption codes separated by commas"
          />
          <p
            style={{
              fontWeight: 400,
              color: "#1C485F",
              fontSize: "14px",
              letterSpacing: "0.7px",
              fontFamily: "Source Sans 3",
              fontStyle: "normal",
            }}
          >
            1. If you possess multiple redemption codes, please ensure they are
            separated by commas.
          </p>
          <p
            style={{
              fontWeight: 400,
              color: "#1C485F",
              fontSize: "14px",
              letterSpacing: "0.7px",
              fontFamily: "Source Sans 3",
              fontStyle: "normal",
              marginTop: 0,
            }}
          >
            2. Please ensure that each redemption code consists of exactly 12
            characters.{" "}
          </p>
          <p
            style={{
              fontWeight: 400,
              color: "#1C485F",
              fontSize: "14px",
              letterSpacing: "0.7px",
              fontFamily: "Source Sans 3",
              fontStyle: "normal",
              marginTop: 0,
            }}
          >
            3. In case of any issue contact us at{" "}
            <a
              href="mailto:support@coldsender.com"
              target="_blank"
              style={{
                textDecoration: "none",
                color: "#1C485F",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
                fontSize: "14px",
                fontWeight: 600,
                outline: "none",
                borderRadius: "4px",
              }}
            >
              support@coldsender.com
            </a>
          </p>

          <button
            onClick={handleApplyPromoCode}
            style={{
              backgroundColor: "#1c485f",
              borderRadius: 6,
              padding: "10px 24px",
              color: "#FFF",
              fontWeight: 700,
              letterSpacing: 0.7,
              alignSelf: "center",
              marginTop: 6,
            }}
          >
            {isLoading ? (
              <CircularProgress sx={{ color: "#FFF" }} size={15} />
            ) : (
              "Apply"
            )}
          </button>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default ApplyPromoCode;
